export default __webpack_public_path__ + "static/asf-75cea58f492a1616c82536aaadf16d34.png";